import * as React from 'react';

const ShopCart = props => (
  <svg
    width={56}
    height={56}
    viewBox="0 0 56 56"
    stroke="none"
    strokeWidth={1}
    fill="#F25757"
    fillRule="evenodd"
    {...props}>
    <path
      d="M31,14 L31,21 C31,24.314 33.686,27 37,27 L49.447,27 L48.706,32.186 C48.545,33.303 47.658,34.174 46.539,34.313 L18.876,37.767 C17.813,37.899 17.014,38.803 17.013,39.876 C17.014,41.05 17.967,42.001 19.14,42 L46.042,42 C47.146,42 48.041,42.895 48.041,44 C48.041,45.104 47.146,46 46.042,46 L18.531,46 C15.545,46.002 13.011,43.807 12.585,40.849 L8.706,13.717 C8.564,12.731 7.72,11.999 6.724,12 L1.999,12 C0.895,12 0,11.105 0,10 C0,8.895 0.895,8 1.999,8 L6.724,8 C9.71,7.998 12.244,10.193 12.669,13.151 L12.791,14 L31,14 Z M18.015,48 C20.221,48.004 22.007,49.796 22.005,52.004 C22.002,54.213 20.212,56.001 18.005,56 C15.799,55.999 14.011,54.208 14.011,52 C14.013,49.789 15.805,47.998 18.015,48 Z M42.038,48 C44.245,48.004 46.031,49.796 46.029,52.004 C46.026,54.213 44.236,56.001 42.029,56 C39.823,55.999 38.034,54.208 38.034,52 C38.037,49.789 39.829,47.998 42.038,48 Z"
      opacity={0.200000003}
    />
    <path d="M46.996,21 L38.993,21 C38.441,21 37.993,20.552 37.993,20 C37.993,19.447 38.441,19 38.993,19 L46.996,19 C49.498,19 51.81,17.665 53.061,15.499 C54.312,13.333 54.312,10.664 53.061,8.497 C51.81,6.331 49.498,4.997 46.996,4.997 L42,4.997 L42,7.495 C41.997,7.685 41.889,7.858 41.719,7.944 C41.549,8.03 41.346,8.015 41.19,7.904 L36.214,4.409 C36.08,4.316 36,4.163 36,4 C36,3.836 36.08,3.683 36.214,3.59 L41.19,0.095 C41.346,-0.015 41.549,-0.031 41.719,0.055 C41.889,0.141 41.997,0.314 42,0.504 L42,2.996 L46.996,2.996 C51.969,2.996 56,7.027 56,11.998 C56,16.97 51.969,21 46.996,21 L46.996,21 Z" />
  </svg>
);

export default ShopCart;



// WEBPACK FOOTER //
// ./src/assets/images/icons/shop-cart.js